import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';

import { Grid, Card, CardContent, Snackbar, Alert } from '@mui/material';

import Trabajador from '../../components/Trabajador';
import MantenimientoForm from '../../components/common/MantenimientoForm';
import { useMantenimiento } from '../../hooks/useMantenimiento';
import trabajadorService from "../../services/trabajadorService";
import { setEntity, activeValidations } from '../../redux/trabajadorSlice';

const Edit = (props) => {
    const sliceKey = "trabajadorEdit";
    const dispatch = useDispatch();
    const params = useParams();
    const navigate = useNavigate();
    const { isReadOnly, setIsReadOnly } = useMantenimiento("trabajador");

    const entity = useSelector((state) => state.trabajador[sliceKey]?.entity) || {};
    const validation = useSelector((state) => state.trabajador[sliceKey]?.validationMessage) || [];

    const [openMessage, setOpenMessage] = useState(false)
    const onCloseMessage = () => { setOpenMessage(!openMessage); }
    const [propsMessage, setPropsMessage] = useState({ severity: "success", message: "" });

    useEffect(() => {
        if (params.id == 0) {
            dispatch(setEntity({ sliceKey: sliceKey, data: { idTrabajador: 0, idPersona: 0, persona: "", numeroDocumento: "", fechaIngreso: null, idCargo: 0, seudonimo: "", idEstado: 2 } }));
        }
    }, [params.id]);

    const postEntity = async () => {
        if (validation.length > 0) {
            dispatch(activeValidations({ sliceKey: sliceKey }));
            setPropsMessage({ severity: "error", message: validation.join(" - ") })
            setOpenMessage(true);
            return;
        }

        await trabajadorService.addUpdateTrabajador({
            idTrabajador: entity.idTrabajador || 0,
            idPersona: entity.idPersona || 0,
            fechaIngreso: entity.fechaIngreso || null,
            idCargo: entity.idCargo || 0,
            seudonimo: entity.seudonimo || "",
            idEstado: entity.idEstado || 2,
        })
            .then((idTrabajador) => {
                dispatch(setEntity({ sliceKey: sliceKey, data: { ...entity, idTrabajador: idTrabajador } }));
                setPropsMessage({ severity: "success", message: "Se guardaron los datos con exito" })
                setOpenMessage(true);
                setIsReadOnly(true);

                if (params.id == 0 && idTrabajador > 0) {
                    navigate("/trabajador/edit/" + idTrabajador);
                }
            })
            .catch(() => {
                setPropsMessage({ severity: "error", message: "Hubo un error" })
                setOpenMessage(true);
            });
    }

    return (
        <div>
            <MantenimientoForm
                title={(params.id == 0 ? "Nuevo" : "Editar") + " Personal"}
                backTo={"/trabajador"}
                onSave={postEntity}
                disabled={isReadOnly}
            >
                <Grid container spacing={1} sx={{
                    "& .MuiGrid-root>.MuiGrid-item": {
                        paddingTop: "8px"
                    },
                }}>
                    <Grid item xs={12} sm={12}>
                        <Card>
                            <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                                <Trabajador sliceKey={sliceKey} isReadOnly={isReadOnly} />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </MantenimientoForm>
            <Snackbar open={openMessage} autoHideDuration={5000} onClose={onCloseMessage}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                <Alert onClose={onCloseMessage} severity={propsMessage.severity}>
                    {propsMessage.message}
                </Alert>
            </Snackbar>
        </div>
    )
}

export default Edit;